import { useGetData, UseGetDataResultReturnType } from "@/component/PageComponent/hooks/requst"
import { CardModule, CustomReportConfig } from "@/component/common/report/reportConfigModel"
import React from "react"
import { ErrorModel, isError } from "@/component/common/error"
import _, { extend } from "lodash"
import { ReportConfig,ReportParams,ServiceQuickBiReportDataParams, encryptReportRequestParams } from "@/component/common/report/report"
import { FORMAT_STRING, numberThousandSeparatorByValueType } from "@/component/Report/share/numberFormat"
import { QuickBiReportDataResponse,serviceQuickBiReportData } from "@/component/Report/services/bi/bi"
import { CountType } from "@/component/Report/share/params"
import { AxiosResponse } from "axios"


interface CustomCardProps {
  reportConfig: ReportConfig,
  moduleItem: CardModule
  dataHandler: UseGetDataResultReturnType<ReportParams> 
  getBiReportCardData(params:ServiceQuickBiReportDataParams):Promise<AxiosResponse<AxiosHttpPromise<QuickBiReportDataResponse>, any>>
  isError(data:ErrorModel):boolean
  enabled?: boolean
}

export function useCustomCardHooks(props: CustomCardProps) {
  const { reportConfig, moduleItem, dataHandler, getBiReportCardData, isError, enabled = true } = props
  const params = { ...dataHandler.params } 
  const { list ,rowFlex} = moduleItem
  const [cardReportData, setCardReportData] = React.useState<QuickBiReportDataResponse>()
  const getData = async ()=>{
    if (!enabled) {
      return
    }
    const encryptedParams = encryptReportRequestParams({
      configData: reportConfig,
      requestParams: dataHandler.params,
    })
    const {count,sortParams,...cardParams}  = encryptedParams
    
    let templateFieldsList = moduleItem.list.filter(item => item.valueType).map(item =>{
      return {
        code: item.valueField,
        valueType: item.valueType
      }
    })
    
    let template_fields = JSON.stringify(templateFieldsList)
    // let res1 = await serviceQuickBiReportData({report:reportConfig.config.slug,source:moduleItem.source,template_fields,...cardParams});
    let axiosRes = await getBiReportCardData({report:reportConfig.config.slug,source:moduleItem.source,template_fields,...cardParams});
    if(isError(axiosRes)){
      return
    }
    let res = axiosRes.data
    let templateFieldsObj = _.keyBy(moduleItem.list,'valueField')
    res.data.listsData = res.data.listsData?.map(item=>{
      Object.keys(item).forEach(key=>{
        if(templateFieldsObj[key]){
          let valueType = templateFieldsObj[key].valueType
          item[key]= numberThousandSeparatorByValueType(item[key],valueType || FORMAT_STRING)
        }
      })
      return item
    })
    setCardReportData(res.data)
  }
  React.useEffect(() => {
    if (!enabled) {
      return
    }
    if(dataHandler.params?.count===CountType.isRequestAll || dataHandler.params.count===undefined){
      getData()
    }
  }, [dataHandler.params, enabled])
  let cardInfo = (cardReportData?.listsData || [])[0]
  let _list = list.map(item => {
    let cardInfo = (cardReportData?.listsData || [])[0] || {}
    let { valueField, relativeRatioField } = item;
    let value = cardInfo[valueField] || '';
    let relativeRatio = cardInfo[relativeRatioField] || '';
    relativeRatio = (Number(relativeRatio) * 100).toFixed(2)
    let hideRelativeRatio = relativeRatioField == undefined
    return {
      ...item,
      value,
      relativeRatio,
      hideRelativeRatio
    }
  })
  return {
    list:_list,
    cardInfo,
    rowFlex,
  }
}
